module.exports = __webpack_public_path__ + "static/media/tiktok.8d2087d3.svg";